import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getCenterFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.global.center_name.label',
      contentValue: `{{ ${entity}center.name }}`,
      description: 'templates.global.center_name.description',
    },
    {
      label: 'templates.global.center_alias.label',
      contentValue: `{{ ${entity}center.alias }}`,
      description: 'templates.global.center_alias.description',
    },
    {
      label: 'templates.global.center_domain.label',
      contentValue: `{{ ${entity}center.domain }}`,
      description: 'templates.global.center_domain.description',
    },
    {
      label: 'templates.global.center_logo_url.label',
      contentValue: `{{ ${entity}center.logo_url }}`,
      description: 'templates.global.center_logo_url.description',
    },
    {
      label: 'templates.global.full_address.label',
      contentValue: `{{ ${entity}center.full_address }}`,
      description: 'templates.global.full_address.description',
    },
  ];
};

export const templateCenter: EntityTemplateVariables = {
  fields: getCenterFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
